// 根据子元素的绝对位置、子元素相对父元素的顺序、父元素，计算父元素的绝对位置
export function getParentPosByChild(childPos, childIndex, parent) {
    let beforeChildLen = 0;
    for (let i = 0; i < childIndex; i++) {
        const { nodeSize = 0 } = parent.child(i);
        beforeChildLen += nodeSize;
    }
    return childPos - beforeChildLen - 1;
}
// 根据子元素、父元素，计算得到子元素在父元素中属于第几个元素
export function getChildNodeIndex(child, parent) {
    const childCount = parent.childCount;
    for (let i = 0; i < childCount; i++) {
        if (parent.child(i) === child) {
            return i;
        }
    }
    return null;
}
//# sourceMappingURL=positon.js.map